import React from 'react';
import {StaticHtmlView} from '../../../../lib/components';
import {X9Content, X9ContentSnapshot} from '../../../../domain';

interface Props {
  x9: X9Content | X9ContentSnapshot;
}

export class X9StaticHtmlView extends React.Component<Props> {
  render() {
    const {Contents} = this.props.x9;

    return <StaticHtmlView html={Contents}/>;
  }
}
